type change = 500 | 1500 | 5000;

export const MEDIUM_CHANGE: change = 500;
export const HARD_CHANGE: change = 1500;
export const WON: change = 5000;
